export default "__VITE_ASSET__DhqRw3hv__"